// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import getFilteredValueField from './getFilteredValueField'

const getSegmentEndIdsFilteredByValue = (paths, filterInput, filterSelect) => {
  const segmentEndIds = []

  const formattedInputValue = (
    filterInput
      .toLowerCase()
      .trim()
  )

  const hasInputSubstring = value => (
    castToString(value)
      .toLowerCase()
      .trim()
      .includes(formattedInputValue)
  )

  // if we're looking at pathName, we're actually evaluating a path level value
  // and not a segment end level value. As such, if we have a pathName match,
  // then we should consider both segment ends to also be a match here
  if (filterSelect === 'pathName') {
    paths.forEach(path => {
      if (hasInputSubstring(path.get(filterSelect))) {
        segmentEndIds.push(
          path.getIn(['site1', 'segmentEndId']),
          path.getIn(['site2', 'segmentEndId'])
        )
      }
    })

  // else the filterSelect is anything other than 'pathName'
  // this strictly maps what else is allowed and checks
  // each path's site1 & site2 for the specified field
  } else {
    const field = getFilteredValueField(filterSelect)

    const checkSegmentEndForSubstring = segmentEnd => {
      const fieldValue = segmentEnd.getIn(field)

      if (hasInputSubstring(fieldValue)) {
        segmentEndIds.push(segmentEnd.get('segmentEndId'))
      }
    }

    paths.forEach(path => {
      checkSegmentEndForSubstring(path.get('site1'))
      checkSegmentEndForSubstring(path.get('site2'))
    })
  }

  return segmentEndIds
}

export default getSegmentEndIdsFilteredByValue
